'use strict';

define(['api/global-api', 'utils/helpers', '../css/jwplayer.less', 'baidu/load-player'], function (GlobalApi, utils) {
    /*global __webpack_public_path__:true*/
    __webpack_public_path__ = utils.loadFrom();

    return GlobalApi.selectPlayer;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/jwplayer.js
 ** module id = 47
 ** module chunks = 0
 **/